import React from 'react';

function hoc(Component){

  return class FormFieldHoc extends React.Component{

    constructor(){
      super(...arguments);
      this.onChange = this.onChange.bind(this);
      this.state = {};
    }

    componentDidMount(){
      this.props.field.on('change', () => {
        this.forceUpdate();
      }, this);

      this.props.field.on('change:field_options', (one, two, three) => {
        this.forceUpdate();
      }, this);
    }

    componentWillUnmount() {
      this.props.field.off(null, null, this);
    }

    componentDidUpdate(){
      /*
       * Using a timeout here because when the breakpoint changes in the editor,
       * the browser has to re-render the component before it knows the correct height
       * at the new breakpoint
       */
      clearTimeout(this._heightTimeout);
      this._heightTimeout = setTimeout(() => {
        this.props.finishedRendering(this.props.field, this.props.size);
      }, 50);
    }

    onChange(value){
      if (this.props.onChange)
        this.props.onChange(value);
      this.setState({value});
    }

    render(){
      let field = this.props.field;
      let name = `form-field-${field.get('id')}`;
      let errors = this.props.errors || {};
      let error = errors[name] ? errors[name][0] : null;
      let errorComp = error ? <div style={{color: '#F00', marginBottom: 10, fontWeight: 'bold'}} className="field-error">{error}</div> : null;
      return <Component {...this.props} data-field-type={field.get('field_type')} value={this.state.value || this.props.value} name={name} id={name} onChange={this.onChange} error={error} errorComponent={errorComp} />;
    }

  };

}

export default hoc;
